var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"one-layer__body"},[_c('div',{staticClass:"child__anchor"},[_c('div',{staticClass:"child__body"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }